<ng-container *ngIf="isLoading$ | async">
  <div *ngIf="showBackdrop" class="loading-backdrop"></div>
  <div class="spinner-container flex-col-center" [ngClass]="getClass()">
    <mat-spinner diameter="60"></mat-spinner>
    <p *ngIf="label" class="loading-label">
      {{ label | translate }}
    </p>
  </div>
</ng-container>
